export default "__VITE_ASSET__DRp9g1E3__"